// extracted by mini-css-extract-plugin
module.exports = {"root":"DiligenceTabs_root__3JWhp"};